import React, {useCallback, useState} from 'react';
import {CATEGORY_DELETE_CONFIRM_METHOD} from '../../constants/issue-templates';
import Text from '@adsk/bim360-matrix-react-text';
import {NotificationTypes, NotificationLevels} from '@adsk/bim360-matrix-react-notification-manager';
import i18n from '../../utils/i18n';

export default ({fetchCategoryTemplatesAction, deleteTemplateCategoryAction, showNotificationAction}) => {
  const [categoryToDelete, setCategoryToDelete] = useState(null);
  const [confirmMethod, setConfirmMethod] = useState(CATEGORY_DELETE_CONFIRM_METHOD.NONE);
  const onDeleteClicked = useCallback(category => {
    setCategoryToDelete(category);
    fetchCategoryTemplatesAction(category.id, {
      onSuccess: ({pagination}) => {
        if (pagination.totalResults > 0) {
          setConfirmMethod(CATEGORY_DELETE_CONFIRM_METHOD.SELECT_TARGET);
        } else {
          setConfirmMethod(CATEGORY_DELETE_CONFIRM_METHOD.CONFIRM_DELETE);
        }
      },
      onError: () => {
        setConfirmMethod(CATEGORY_DELETE_CONFIRM_METHOD.SELECT_TARGET);
      }
    });
  }, [fetchCategoryTemplatesAction]);

  const resetDeleteState = useCallback(() => {
    setConfirmMethod(CATEGORY_DELETE_CONFIRM_METHOD.NONE);
    setCategoryToDelete(null);
  }, []);

  const onDeleteConfirmed = useCallback(templatesTarget => {
    deleteTemplateCategoryAction(categoryToDelete.id, {
      templatesTarget,
      onSuccess: () => {
        resetDeleteState();
        showNotificationAction({
          type: NotificationTypes.TOAST,
          level: NotificationLevels.SUCCESS,
          message: (
            <Text hasHTML>
              {i18n.t('templatesGrid.manageCategoriesModal.deleteSuccess', {
                title: categoryToDelete.title
              })}
            </Text>
          )
        });
      },
      onError: () => {
        resetDeleteState();
        showNotificationAction({
          type: NotificationTypes.TOAST,
          level: NotificationLevels.ERROR,
          message: i18n.t('templatesGrid.manageCategoriesModal.error.deleteFailed')
        });
      }
    });
  }, [categoryToDelete, deleteTemplateCategoryAction, resetDeleteState, showNotificationAction]);

  return {categoryToDelete, confirmMethod, onDeleteClicked, onDeleteConfirmed, onDeleteModalExited: resetDeleteState};
};
